import { ReactElement } from 'react';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { StyledFlex, TextSeparator, TextSeparatorType, TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, patientNameFormatter } from '@dreryk/react-common';

import { PatientGroupTags } from '~libs.desktop.patient-groups';

import { translationKeys } from '../../translations';

type PatientTextViewProps = {
   patient: PatientSimple;
};

export const PatientTextView = (props: PatientTextViewProps): ReactElement => {
   return (
      <TextView testId={'patient'} label={translationKeys.patient}>
         <StyledFlex direction={'column'} gap={'8px'}>
            <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
               <span>
                  {patientNameFormatter(props.patient, getCustomFormattingContext({ options: { order: 'firstLast' } }))}
               </span>
               {props.patient.formattedAge ? <span>{props.patient.formattedAge}</span> : null}
            </TextSeparator>
            <PatientGroupTags patient={props.patient} />
         </StyledFlex>
      </TextView>
   );
};
